module.exports = __webpack_public_path__ + "img/indu_12.73ec7840.png";